'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Link = _interopRequireDefault(require("Pure/Link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let app = window.app;
class CandidateAccountPage extends _react.Component {
  state = {
    candidate_id: document.location.pathname.split('/validation-charte/')[1],
    loading: true
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.verifyValidationAccount();
  }
  verifyValidationAccount = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/candidate/validate-candidate-account', {
      candidate_id: state.candidate_id
    }).then(function (xhr, response) {
      component.setState({
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-carbon']
    }) : undefined;
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Validation du compte | AspieJob"
    }, props), /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title c-title--center "
    }, "Validation du compte"), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content o-content--account"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "u-full-width u-text-center"
    }, "Vous avez termin\xE9 l'inscription de votre compte AspieJob", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/",
      className: "c-btn u-margin-top-20"
    }, "Retour \xE0 la page d'accueil")), loader));
    return output;
  }
}
exports.default = CandidateAccountPage;
